/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { register } from '../../../redux/registration_block/registrationActions';
import { BusinessListing } from '../../../redux/listing_block/business/businessActions';

const RegisterBusiness = () => {
  const navigate = useNavigate();
  const [designation, setDesignation] = useState('');
  const [advertisementHeadline, setAdvertisementHeadline] = useState('');
  const [introduction, setIntroduction] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [establishmentYear, setEstablishmentYear] = useState('');
  const [employeeCount, setEmployeeCount] = useState('');
  const [entityType, setEntityType] = useState('');
  const [businessType, setBusinessType] = useState('');
  const [industrySector, setIndustrySector] = useState('');
  const [businessWebsite, setBusinessWebsite] = useState('');
  const [facilities, setFacilities] = useState('');
  const [businessSummary, setBusinessSummary] = useState('');
  const [annualSales, setAnnualSales] = useState('');
  const [inventoryValue, setInventoryValue] = useState('');
  const [grossIncome, setGrossIncome] = useState('');
  const [ebitda, setEbitda] = useState('');
  const [ebitdaMargin, setEbitdaMargin] = useState('');
  const [rentals, setRentals] = useState('');
  const [companyHeadName, setCompanyHeadName] = useState('');
  const [companyHeadEmail, setCompanyHeadEmail] = useState('');
  const [companyHeadDesignation, setCompanyHeadDesignation] = useState('');
  const [managementTeam, setManagementTeam] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyCity, setCompanyCity] = useState('');
  const [companyEmail, setCompanyEmail] = useState('');
  const [lookingFor, setLookingFor] = useState('');
  const [oneLinePitch, setOneLinePitch] = useState('');
  const [businessPhoto, setBusinessPhoto] = useState('');
  const [businessDocuments, setBusinessDocuments] = useState('');

  const [loading, setLoading] = useState(false);

  const { message } = useSelector((state) => state.Message);

  const dispatch = useDispatch();

  const onChangeDesignation = (e) => {
    const designation = e.target.value;
    setDesignation(designation);
  };

  const onChangeAdvertisementHeadline = (e) => {
    const advertisementHeadline = e.target.value;
    setAdvertisementHeadline(advertisementHeadline);
  };

  const onChangeIntroduction = (e) => {
    const introduction = e.target.value;
    setIntroduction(introduction);
  };

  const onCompanyName = (e) => {
    const companyName = e.target.value;
    setCompanyName(companyName);
  };

  const onEstablishmentYear = (e) => {
    const establishmentYear = e.target.value;
    setEstablishmentYear(establishmentYear);
  };

  const onChangeEmployeeCount = (e) => {
    const employeeCount = e.target.value;
    setEmployeeCount(employeeCount);
  };

  const onChangeEntityType = (e) => {
    const entityType = e.target.value;
    setEntityType(entityType);
  };

  const onChangeBusinessType = (e) => {
    const businessType = e.target.value;
    setBusinessType(businessType);
  };

  const onChangeIndustrySector = (e) => {
    const industrySector = e.target.value;
    setIndustrySector(industrySector);
  };

  const onChangeBusinessWebsite = (e) => {
    const businessWebsite = e.target.value;
    setBusinessWebsite(businessWebsite);
  };

  const onChangeFacilities = (e) => {
    const facilities = e.target.value;
    setFacilities(facilities);
  };

  const onChangeBusinessSummary = (e) => {
    const businessSummary = e.target.value;
    setBusinessSummary(businessSummary);
  };

  const onChangeAnnualSales = (e) => {
    const annualSales = e.target.value;
    setAnnualSales(annualSales);
  };

  const onChangeInventoryValue = (e) => {
    const inventoryValue = e.target.value;
    setInventoryValue(inventoryValue);
  };

  const onChangeGrossIncome = (e) => {
    const grossIncome = e.target.value;
    setGrossIncome(grossIncome);
  };

  const onChangeEbitda = (e) => {
    const ebitda = e.target.value;
    setEbitda(ebitda);
  };

  const onChangeEbitdaMargin = (e) => {
    const ebitdaMargin = e.target.value;
    setEbitdaMargin(ebitdaMargin);
  };

  const onChangeRentals = (e) => {
    const rentals = e.target.value;
    setRentals(rentals);
  };

  const onChangeCompanyHeadName = (e) => {
    const companyHeadName = e.target.value;
    setCompanyHeadName(companyHeadName);
  };

  const onChangeCompanyHeadEmail = (e) => {
    const companyHeadEmail = e.target.value;
    setCompanyHeadEmail(companyHeadEmail);
  };

  const onChangeCompanyHeadDesignation = (e) => {
    const companyHeadDesignation = e.target.value;
    setCompanyHeadDesignation(companyHeadDesignation);
  };

  const onChangeManagementTeam = (e) => {
    const managementTeam = e.target.value;
    setManagementTeam(managementTeam);
  };

  const onChangeCompanyAddress = (e) => {
    const companyAddress = e.target.value;
    setCompanyAddress(companyAddress);
  };

  const onChangeCompanyCity = (e) => {
    const companyCity = e.target.value;
    setCompanyCity(companyCity);
  };

  const onChangeCompanyEmail = (e) => {
    const companyEmail = e.target.value;
    setCompanyEmail(companyEmail);
  };

  const onChangeLookingFor = (e) => {
    const lookingFor = e.target.value;
    setLookingFor(lookingFor);
  };

  const onChangeOneLinePitch = (e) => {
    const oneLinePitch = e.target.value;
    setOneLinePitch(oneLinePitch);
  };

  const onChangeBusinessPhoto = (e) => {
    const businessPhoto = e.target.value;
    setBusinessPhoto(businessPhoto);
  };

  const onChangeBusinessDocuments = (e) => {
    const businessDocuments = e.target.value;
    setBusinessDocuments(businessDocuments);
  };

  const handleRegisterBusiness = (event) => {
    event.preventDefault();
    setLoading(true);
    const businessDetails = {
      designation,
      advertisementHeadline,
      introduction,
      companyName,
      establishmentYear,
      employeeCount,
      entityType,
      businessType,
      industrySector,
      businessWebsite,
      facilities,
      businessSummary,
      annualSales,
      inventoryValue,
      grossIncome,
      ebitda,
      ebitdaMargin,
      rentals,
      companyHeadName,
      companyHeadEmail,
      companyHeadDesignation,
      managementTeam,
      companyAddress,
      companyCity,
      companyEmail,
      lookingFor,
      oneLinePitch,
      businessPhoto,
      businessDocuments,
    };
    dispatch(register(businessDetails))
      .then(() => {
        setLoading(false);
        dispatch(BusinessListing());
        navigate('/registration');
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className="col-md-12">
      <div className="card business-registration-card">
        <Form onSubmit={handleRegisterBusiness}>
          <div>
            <Form.Group as={Row} className="mb-3" controlId="formPlaintextDesignation">
              <Form.Label column sm="2">
                Designation
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="designation"
                  name="designation"
                  type="text"
                  placeholder="Designation"
                  value={designation}
                  onChange={onChangeDesignation}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formAdvertisementHeadline">
              <Form.Label column sm="2">
                Advertisement Headline
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="advertisementHeadline"
                  name="advertisementHeadline"
                  type="text"
                  placeholder="Advertisement Headline"
                  value={advertisementHeadline}
                  onChange={onChangeAdvertisementHeadline}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formIntroduction">
              <Form.Label column sm="2">
                Introduction
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="introduction"
                  name="introduction"
                  type="text"
                  placeholder="Introduction"
                  value={introduction}
                  onChange={onChangeIntroduction}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyName">
              <Form.Label column sm="2">
                Company Name
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyName"
                  name="companyName"
                  type="Text"
                  placeholder="Company Name"
                  value={companyName}
                  onChange={onCompanyName}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formEstablishmentYear">
              <Form.Label column sm="2">
                Establishment Year
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="establishmentYear"
                  name="establishmentYear"
                  type="Text"
                  placeholder="Establishment Year"
                  value={establishmentYear}
                  onChange={onEstablishmentYear}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formEmployeeCount">
              <Form.Label column sm="2">
                Employee Count
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="employeeCount"
                  name="employeeCount"
                  type="text"
                  placeholder="Employee Count"
                  value={employeeCount}
                  onChange={onChangeEmployeeCount}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formEntityType">
              <Form.Label column sm="2">
                Entity Type
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="entityType"
                  name="entityType"
                  type="text"
                  placeholder="Entity Type"
                  value={entityType}
                  onChange={onChangeEntityType}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formBusinessType">
              <Form.Label column sm="2">
                Business Type
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="businessType"
                  name="businessType"
                  type="text"
                  placeholder="Business Type"
                  value={businessType}
                  onChange={onChangeBusinessType}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formIndustrySector">
              <Form.Label column sm="2">
                Industry Sector
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="industrySector"
                  name="industrySector"
                  type="text"
                  placeholder="Industry Sector"
                  value={industrySector}
                  onChange={onChangeIndustrySector}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formBusinessWebsite">
              <Form.Label column sm="2">
                Business Website
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="businessWebsite"
                  name="businessWebsite"
                  type="text"
                  placeholder="Business Website"
                  value={businessWebsite}
                  onChange={onChangeBusinessWebsite}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formFacilities">
              <Form.Label column sm="2">
                Facilities
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="facilities"
                  name="facilities"
                  type="text"
                  placeholder="Facilities"
                  value={facilities}
                  onChange={onChangeFacilities}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formBusinessSummary">
              <Form.Label column sm="2">
                Business Summary
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="businessSummary"
                  name="businessSummary"
                  type="text"
                  placeholder="Business Summary"
                  value={businessSummary}
                  onChange={onChangeBusinessSummary}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formAnnualSales">
              <Form.Label column sm="2">
                Annual Sales
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="annualSales"
                  name="annualSales"
                  type="text"
                  placeholder="Annual Sales"
                  value={annualSales}
                  onChange={onChangeAnnualSales}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formInventoryValue">
              <Form.Label column sm="2">
                Inventory Value
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="inventoryValue"
                  name="inventoryValue"
                  type="text"
                  placeholder="Inventory Value"
                  value={inventoryValue}
                  onChange={onChangeInventoryValue}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formGrossIncome">
              <Form.Label column sm="2">
                Gross Income
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="grossIncome"
                  name="grossIncome"
                  type="text"
                  placeholder="Gross Income"
                  value={grossIncome}
                  onChange={onChangeGrossIncome}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formEbitda">
              <Form.Label column sm="2">
                ebitda
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="ebitda"
                  name="ebitda"
                  type="text"
                  placeholder="ebitda"
                  value={ebitda}
                  onChange={onChangeEbitda}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formEbitdaMargin">
              <Form.Label column sm="2">
                Ebitda Margin
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="ebitdaMargin"
                  name="ebitdaMargin"
                  type="text"
                  placeholder="Ebitda Margin"
                  value={ebitdaMargin}
                  onChange={onChangeEbitdaMargin}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formRentals">
              <Form.Label column sm="2">
                Rentals
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="rentals"
                  name="rentals"
                  type="text"
                  placeholder="Rentals"
                  value={rentals}
                  onChange={onChangeRentals}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyHeadName">
              <Form.Label column sm="2">
                company Head Name
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyHeadName"
                  name="companyHeadName"
                  type="text"
                  placeholder="Company Head Name"
                  value={companyHeadName}
                  onChange={onChangeCompanyHeadName}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyHeadEmail">
              <Form.Label column sm="2">
                Company Head Email
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyHeadEmail"
                  name="companyHeadEmail"
                  type="email"
                  placeholder="Company Head Email"
                  value={companyHeadEmail}
                  onChange={onChangeCompanyHeadEmail}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyHeadDesignation">
              <Form.Label column sm="2">
                Company Head Designation
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyHeadDesignation"
                  name="companyHeadDesignation"
                  type="text"
                  placeholder="Company Head Designation"
                  value={companyHeadDesignation}
                  onChange={onChangeCompanyHeadDesignation}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formManagementTeam">
              <Form.Label column sm="2">
                Management Team
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="managementTeam"
                  name="managementTeam"
                  type="text"
                  placeholder="Management Team"
                  value={managementTeam}
                  onChange={onChangeManagementTeam}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyAddress">
              <Form.Label column sm="2">
                company Address
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyAddress"
                  name="companyAddress"
                  type="text"
                  placeholder="Company Address"
                  value={companyAddress}
                  onChange={onChangeCompanyAddress}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyCity">
              <Form.Label column sm="2">
                Company City
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyCity"
                  name="companyCity"
                  type="text"
                  placeholder="Company City"
                  value={companyCity}
                  onChange={onChangeCompanyCity}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formCompanyEmail">
              <Form.Label column sm="2">
                Company Email
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="companyEmail"
                  name="companyEmail"
                  type="email"
                  placeholder="CompanyEmail"
                  value={companyEmail}
                  onChange={onChangeCompanyEmail}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formLookingFor">
              <Form.Label column sm="2">
                Looking For
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="lookingFor"
                  name="lookingFor"
                  type="text"
                  placeholder="Looking For"
                  value={lookingFor}
                  onChange={onChangeLookingFor}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formOneLinePitch">
              <Form.Label column sm="2">
                One Line Pitch
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="oneLinePitch"
                  name="oneLinePitch"
                  type="text"
                  placeholder="One Line Pitch"
                  value={oneLinePitch}
                  onChange={onChangeOneLinePitch}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formBusinessPhoto">
              <Form.Label column sm="2">
                Business Photos
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="businessPhoto"
                  name="businessPhoto"
                  type="text"
                  placeholder="Business Photo"
                  value={businessPhoto}
                  onChange={onChangeBusinessPhoto}
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formBusinessDocuments">
              <Form.Label column sm="2">
                Business Documents
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  id="businessDocuments"
                  name="businessDocuments"
                  type="text"
                  placeholder="Business Documents"
                  value={businessDocuments}
                  onChange={onChangeBusinessDocuments}
                />
              </Col>
            </Form.Group>
            <br />
            <Form.Group as={Row} className="mb-3">
              <Col sm={{ span: 0, offset: 5 }}>
                <Button type="submit">
                  {loading && (
                  <span className="spinner-border spinner-border-sm" />
                  )}
                  Save
                </Button>
              </Col>
            </Form.Group>
          </div>
          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
};

export default RegisterBusiness;
